import { getAppointmentActionType } from "../../../core/store/appointmentSlice";
import { getCurrentPracticeAppointmentRequestFlags } from "../../../core/store/chainSlice";
import { useMainStore } from "../../../core/store/mainStore";

/**
 * Which master data the Kontaktdaten screen asks for, and which of it blocks the request. The form
 * and the payload guard read the same derivation, so the submit button and the guard cannot disagree.
 */
export const useAppointmentContactRequirements = () => {
  const flags = useMainStore(getCurrentPracticeAppointmentRequestFlags);
  const actionType = useMainStore(getAppointmentActionType);

  const showEmail = !flags?.hideEmail;
  const showBirthday = !flags?.hideBirthday;

  return {
    showEmail,
    showBirthday,
    // Someone trying to cancel or reschedule is not made to produce a birthdate first.
    birthdayRequired: showBirthday && actionType === "booking",
  };
};
